import React, { useState } from "react";
import Modal, { modalStyles as m } from "./Modal";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import NumericInput from "../NumericInput";

// Custom quantity multiplier entry (the "Custom" chip).
export default function CustomQtyModal({ onApply, onClose }) {
  const [value, setValue] = useState(0);
  const apply = () => {
    const v = Math.floor(Number(value) || 0);
    if (v <= 0) return ToastifyAlert("Enter a quantity", "error");
    onApply(v); // NumericInput already caps at max
    onClose();
  };
  return (
    <Modal title="Custom quantity" onClose={onClose} width={340}>
      <div style={m.label}>Quantity multiplier</div>
      <NumericInput style={m.input} value={value} onChange={setValue} decimals={0} max={10000} onEnter={apply} autoFocus />
      <button style={m.primary} onClick={apply}>Set quantity</button>
    </Modal>
  );
}
